import { Button } from '@efexteam/components';
import { Actions, Subjects, usePermission } from '@efexteam/permission-manager';
import useBoolean from '@main-hooks/useBoolean';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import TwoFactor from './components/TwoFactor';

const Security = () => {
  const userProfile = useSelector(selectProfileData);
  const { t } = useTranslation();
  const [
    isVisibleTwoFactorModal,
    { setFalse: hideTwoFactorModal, setTrue: showTwoFactorModal },
  ] = useBoolean(false);
  const { can } = usePermission();

  if (!can(Actions.MANAGE, Subjects.ACCOUNT)) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="min-h-[80vh] p-5">
      <Card>
        <CardContent>
          <Grid
            container
            spacing={2}
            className="max-w-[600px] mr-auto rounded-lg bg-red"
          >
            <Grid item xs={12}>
              <Typography variant="h6">{t('tfTitle')}</Typography>
              <Typography className="py-3">{t('tfDescription')}</Typography>
              <Button
                appearance="primary"
                variant="outlined"
                onClick={showTwoFactorModal}
                className="w-full cursor-pointer"
                color={userProfile?.has2FA ? 'error' : 'primary'}
              >
                {t(!userProfile?.has2FA ? 'tfCTA' : 'tfCTADisable')}
                <ChevronRightIcon className="!ml-auto" />
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {isVisibleTwoFactorModal ? (
        <TwoFactor
          open={isVisibleTwoFactorModal}
          onClose={hideTwoFactorModal}
        />
      ) : null}
    </div>
  );
};

export default Security;
